export default __webpack_public_path__ + "static/natasha-a7f7dae80b2acffb43ed65432b05ffa9.png";